import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Header,
  Segment,
  Form,
  Divider,
  Grid,
  Input,
  Image,
  Label,
} from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MyTextArea from '../../../../app/common/form/MyTextArea';
import MySelectInput from '../../../../app/common/form/MySelectInput';
import { outwardpurposeOptions } from '../../../../app/common/options/inwardoutwardOptions/outwardpurposeOptions';
import {
  DeliveryRequest,
  DeliveryRequestInitialState,
} from '../../../../app/models/deliveryRequest';
import { v4 as uuid } from 'uuid';
import VerifyFileUpload from '../VerifyImageUpload/VerifyFileUpload';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';
import ImageTag from '../../../../features/Profile/RenderImage';
import { Activity } from '../../../../app/models/activity';
import agent from '../../../../app/api/agent';

export default observer(function OrderRequestForm() {
  const {
    activityStore,
    userStore: { user },
    dashboardStore,
    DeliveryStore: { listOrderRegister, outwardDetails },
    commonStore,
  } = useStore();
  const [assetId, setAssetId] = useState('');
  const [workLevelName, setWorkLevelName] = useState<string>('');
  const [borrowerName, setBorrowerName] = useState('');
  const [DeliveryState, setDeliveryState] = useState<DeliveryRequest>(
    DeliveryRequestInitialState,
  );
  const [imageUrl, setimageUrl] = useState<imageData[]>([]);
  const [selectedItemLevel, setSelectedItemLevel] = useState<
    Activity | undefined
  >();
  const [error, setError] = useState<string>('');

  // useEffect(() => {
  //   if (workLevelsList.length > 0) {
  //     const temp = workLevelsList.map((x) => ({
  //       key: x.id,
  //       text: x.title,
  //       value: x.id,
  //     }));
  //     setWorklevelOptions(temp);
  //   }
  // }, [workLevelsList]);

  useEffect(() => {
    if (dashboardStore.dashboard.verifyImageUrl.length > 0) {
      setimageUrl(dashboardStore.dashboard.verifyImageUrl);
    }
  }, [dashboardStore.dashboard.verifyImageUrl]);

  // useEffect(() => {
  //   const optionData = filmTitleList?.map((x) => ({
  //     key: x.id,
  //     text: x.title,
  //     value: x.id,
  //   }));
  //   if (optionData !== undefined) {
  //     setTitleOptions(optionData);
  //   }
  // }, [filmTitleList]);

  const handleIDChange = async (e: SyntheticEvent, data: { value: string }) => {
    const response = await outwardDetails({ itemId: data.value });
    setAssetId(data.value);
    if (typeof response === 'string') {
      setError(response);
    } else {
      setWorkLevelName(response?.itemGroupTitle || '');
      setBorrowerName(user?.displayName || '');
      const getDate = new Date().toISOString().slice(0, 10).split('-'); //create an array
      const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; //setting the date time
      if (response && user) {
        const tempAct: any = await agent.Activities.details(data.value);
        const newArr = {
          ...DeliveryState,
          itemGroupId: response?.itemGroupId,
          itemId: data.value,
          assetName: response?.itemTitle,
          numberOfElement: response?.elementOrPrint,
          element: response?.elementType,
          dateRequestRaised: _date,
          dateOrderRegistered: new Date().toISOString(),
          dateOfDelivery: new Date().toISOString(),
          dateOfReturn: new Date().toISOString(),
          userId: user?.id,
          isActive: true,
          userName: user?.username,
          borrowerName: user?.displayName,
          borrowerAddress: user?.addressLine1,
          borrowerCode: user?.postalCode,
          borrowerPhoneNumber: user?.phoneNumber,
          borrowerEmail: user?.email,
        };
        setDeliveryState(newArr);
        setSelectedItemLevel(tempAct.data);
      } else {
        setDeliveryState(DeliveryRequestInitialState);
        setSelectedItemLevel(undefined);
        setWorkLevelName('');
        setBorrowerName('');
      }
    }
  };

  const handleFormSubmit = async (delivery: DeliveryRequest) => {
    // const response = (await outwardReqValidation({ itemId: assetId })) || '';
    // if (response !== 'Okay to proceed') {
    //   toast.info(response);
    // } else {
    const newArr = {
      ...DeliveryState,
      id: uuid(),
      orderRequestId: uuid(),
      purpose: delivery.purpose,
      dateRequestRaised: new Date().toISOString(),
      orderRequest: true,
      files: imageUrl,
    };
    if (selectedItemLevel !== undefined) {
      const ActivityArr = {
        ...selectedItemLevel,
        itemDeliveryRequest: [newArr],
        movementdate: new Date().toISOString(),
        isActive: true,
        itemCreatedBy:
          user?.customerName !== undefined ? user?.customerName : '',
        isDelivery: true,
        asset_tracking_status: 'Delivery Request Created',
        assignedUsers: [],
        files: [],
      };
      new Promise((resolve) => {
        activityStore.createDelivery(ActivityArr);
        sendRespectiveEmail(
          'Notification',
          ActivityArr.title,
          'Created Outward Request',
          '',
          `${ActivityArr.type} is outward requested successfully on`,
        );
        //historyfunc
        let defaultStatus = `Order request (${ActivityArr.title}) placed by ${user?.displayName}`;
        commonStore.updateHistoryAlonePOST(
          defaultStatus,
          assetId || '',
          undefined,
          true,
          true,
        );
        resolve('');
      }).then(() => {
        setTimeout(() => {
          listOrderRegister();
          dashboardStore.dashboard.valueForL3Inventory = 'Order Register';
        }, 700);
      });
    }
    handleCancel();
    // }
  };
  const handleCancel = () => {
    dashboardStore.setVerifyUrlResponse([]);
    setDeliveryState(DeliveryRequestInitialState);
    setimageUrl([]);
    setAssetId('');
    setWorkLevelName('');
    setBorrowerName('');
    setSelectedItemLevel(undefined);
  };
  return (
    <Segment
      clearing
      style={{
        Responsive: true,
        padding: '10px',
        width: '70vw',
        maxWidth: '1200px',
        margin: '26px auto',
      }}
      responsive={true}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content={
          (
            userLanguage[0].Level3InventoryDeliveryOrderRequest?.IDORFH01 as any
          )?.[`${commonStore.language.key}`]
        } //"Order Request"
        sub
        color="grey"
      />
      <Formik
        enableReinitialize
        initialValues={DeliveryState}
        onSubmit={(values) => handleFormSubmit(values)}
        validationSchema={Yup.object({
          purpose: Yup.string().required().max(500),
        })}
      >
        {({ handleSubmit, isSubmitting, isValid, dirty }) => (
          <Form
            className="semantic ui form"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Header />
            <Header />
            <Form.Field
              control={Input}
              label="Asset ID"
              name="assetId"
              placeholder="AssetID"
              value={assetId}
              onChange={handleIDChange}
            />
            {error && (
              <Label basic color="red" style={{ marginBottom: '20px' }}>
                {error}
              </Label>
            )}
            <Form.Group fluid widths="equal">
              <Form.Field
                control={Input}
                label="Asset Name"
                name="assetName"
                placeholder="Asset Name"
                value={DeliveryState.assetName}
                style={{ opacity: '0.65', pointerEvents: 'none' }}
              />
              <Form.Field
                control={Input}
                label={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORL01 as any
                  )?.[`${commonStore.language.key}`]
                }
                name="itemGroupId"
                placeholder={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORL01 as any
                  )?.[`${commonStore.language.key}`]
                }
                value={workLevelName}
                style={{ opacity: '0.65', pointerEvents: 'none' }}
              />
            </Form.Group>
            <Form.Group fluid widths="equal">
              <Form.Field
                control={Input}
                label={
                  commonStore.hfcCustomerChanges
                    ? 'Print'
                    : (
                        userLanguage[0].Level3InventoryDeliveryOrderRequest
                          ?.IDORL03 as any
                      )?.[`${commonStore.language.key}`]
                } //"Number of Elements"
                name="numberOfElement"
                placeholder={
                  commonStore.hfcCustomerChanges
                    ? 'Print'
                    : (
                        userLanguage[0].Level3InventoryDeliveryOrderRequest
                          ?.IDORTB03 as any
                      )?.[`${commonStore.language.key}`]
                } //"Number Of Element"
                value={DeliveryState.numberOfElement}
                style={{ opacity: '0.65', pointerEvents: 'none' }}
              />

              <Form.Field
                control={Input}
                label={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORL04 as any
                  )?.[`${commonStore.language.key}`]
                } //"Borrower Name"
                name="borrowerName"
                placeholder={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORTB04 as any
                  )?.[`${commonStore.language.key}`]
                } //"Borrower Name"
                value={borrowerName}
                style={{ opacity: '0.65', pointerEvents: 'none' }}
              />
              <Form.Field
                label={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORL05 as any
                  )?.[`${commonStore.language.key}`]
                } //"Date"
                name="dateRequestRaised"
                placeholderText={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORTB05 as any
                  )?.[`${commonStore.language.key}`]
                } //"Select Date"
                value={DeliveryState.dateRequestRaised}
                control={Input}
                showTimeSelect
                timeCaption="Time"
                dateFormat="MMMM d, yyyy h:mm aa"
                style={{ opacity: '0.65', pointerEvents: 'none' }}
              />
            </Form.Group>

            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Form fluid>
                    <div>
                      <MyTextArea
                        placeholder={
                          (
                            userLanguage[0].Level3InventoryDeliveryOrderRequest
                              ?.IDORTA01 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Purpose"
                        name={'purpose'}
                        rows={1}
                      />
                      <Divider
                        horizontal
                        //OR
                      >
                        {
                          (
                            userLanguage[0].Level3InventoryDeliveryOrderRequest
                              ?.IDORL06 as any
                          )?.[`${commonStore.language.key}`]
                        }
                      </Divider>

                      <MySelectInput
                        options={outwardpurposeOptions}
                        label={
                          (
                            userLanguage[0].Level3InventoryDeliveryOrderRequest
                              ?.IDORL07 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Select Purpose"
                        placeholder={
                          (
                            userLanguage[0].Level3InventoryDeliveryOrderRequest
                              ?.IDORDD03 as any
                          )?.[`${commonStore.language.key}`]
                        } //"Select Purpose"
                        clearable
                        name="purpose"
                      />
                    </div>
                  </Form>
                </Grid.Column>
                <Grid.Column>
                  <VerifyFileUpload
                    nameData="order"
                    workLevelIdForOrderRequest={DeliveryState.itemGroupId}
                    itemIdForOrderRequest={DeliveryState.itemId}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {imageUrl?.length > 0 && (
              <Segment>
                <Grid>
                  {imageUrl?.map((url) => {
                    return (
                      <Grid.Column textAlign={'center'} key={url.url} width={2}>
                        {url.url.includes('pdf') ? (
                          <Image
                            src={'/assets/documents.jpg'}
                            alt="/assets/documents.jpg"
                          />
                        ) : (
                          <ImageTag
                            imageUrl={url?.url}
                            defaultUrl="/assets/documents.jpg"
                          />
                        )}
                      </Grid.Column>
                    );
                  })}
                </Grid>
              </Segment>
            )}

            <Header />
            <Button.Group floated="right">
              <Button
                onClick={handleCancel}
                //Cancel
              >
                {
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORB02 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
              <Button.Or
                text={
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORB03 as any
                  )?.[`${commonStore.language.key}`]
                }
              />
              <Button
                type="submit"
                content="Submit"
                positive
                disabled={
                  DeliveryState.itemGroupId === '' ||
                  DeliveryState.itemId === ''
                }
                //Save
              >
                {' '}
                {
                  (
                    userLanguage[0].Level3InventoryDeliveryOrderRequest
                      ?.IDORB04 as any
                  )?.[`${commonStore.language.key}`]
                }
              </Button>
            </Button.Group>
          </Form>
        )}
      </Formik>
    </Segment>
  );
});

interface imageData {
  fileId: string;
  id: string;
  url: string;
  fileName: string;
}
